import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import s from './AsyncLabelConfirmation.module.css';
import Icon from '../Icon';
import { PRINTERLESS_MAIL } from '../../constants/returnMethods';
import DEFAULT_COPY from '../../constants/defaultCopy';

const DEFAULT_EN_COPY = DEFAULT_COPY.en;

const mapStateToProps = ({
  language = {},
  returnMethods: { selectedMethodKey } = {},
  returnConfirmation: { primaryEmail } = {},
}) => ({
  primaryEmail,
  header:
    language['returns.step_async_label.header'] ||
    DEFAULT_EN_COPY['returns.step_async_label.header'],
  description:
    selectedMethodKey === PRINTERLESS_MAIL
      ? language['returns.step_async_label.printerless_desc'] ||
        DEFAULT_EN_COPY['returns.step_async_label.printerless_desc']
      : language['returns.step_async_label.desc'] ||
        DEFAULT_EN_COPY['returns.step_async_label.desc'],
});

const propTypes = {
  primaryEmail: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

const AsyncLabelConfirmation = ({ primaryEmail, header, description }) => (
  <div className={s.step_async_label_header_container}>
    <div aria-label="Transaction Success" role="alert" className="async-icon">
      <Icon.SuccessCheckmark className="cta-icon" />
    </div>
    <h2 dangerouslySetInnerHTML={{ __html: header }} />

    <div className={s.step_async_label_description}>
      {description.replace('{email}', primaryEmail)}
    </div>
  </div>
);

AsyncLabelConfirmation.propTypes = propTypes;
export { AsyncLabelConfirmation, mapStateToProps };
export default connect(mapStateToProps)(AsyncLabelConfirmation);
